import React from 'react';
import { Priority } from '../types';

interface PriorityIndicatorProps {
  priority: Priority;
  size?: 'sm' | 'lg';
}

export const PriorityIndicator: React.FC<PriorityIndicatorProps> = ({ priority, size = 'sm' }) => {
  const colors = {
    high: 'bg-red-500',
    medium: 'bg-yellow-500',
    low: 'bg-green-500',
    loading: 'bg-blue-500 animate-pulse'
  };

  const sizes = {
    sm: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  return (
    <div className={`${colors[priority]} ${sizes[size]} rounded-full`} />
  );
};